module.exports = __webpack_public_path__ + "img/yanbao_nongchanpin_head.a63235f9.png";